import commonConfig from './common';
import getEnvironmentConfig from './per-environment';

const environmentConfig = getEnvironmentConfig();
export default { ...commonConfig, ...environmentConfig };
